
export let bottomFullMixin = {
  mounted () {
    this.refreshHeight()
  },
  updated () {
    this.refreshHeight()
  },
  methods: {
    refreshHeight () {
      var bottomFullView = this.$refs.bottomFullView
      bottomFullView = bottomFullView && bottomFullView.$el ? bottomFullView.$el : bottomFullView
      if (bottomFullView) {
        bottomFullView.style.height = window.innerHeight - bottomFullView.offsetTop + 'px'
      }
    }
  }
}
